import { useState } from "react";
import Button from "../../../../../../../../library/button";
import { Text } from "../../../../../../../../library/text";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { ButtonsWrapper, TextWrapper } from "./styled";
import useDeleteWorkspace from "../../../../../../../../hooks/useDeleteWorkspace";
import { useAuth } from "../../../../../../../../AuthContext";

interface Props {
  onSuccess: () => void;
  onError: () => void;
}

const DeleteModal = ({ onSuccess, onError }: Props) => {
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { deleteWorkspace } = useDeleteWorkspace();

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const workspaceId = currentUser?.selectedWorkspace?.id;
      if (!workspaceId) {
        throw new Error("No workspace selected");
      }
      const deletion = await deleteWorkspace(workspaceId);
      if (deletion.error === null) {
        onSuccess();
      } else {
        throw new Error("Failed");
      }
    } catch (e) {
      onError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <TextWrapper>
        <Text size="small" color="dark">
          Dersom du sletter dette arbeidsmiljøet vil alle lyd- og videofiler,
          transkriberinger og revisjoner bli permanent slettet - og alle
          medlemmer, inkludert deg selv, vil miste tilgangen for godt.
        </Text>
      </TextWrapper>
      <ButtonsWrapper>
        <Button
          onClick={handleDelete}
          disabled={false}
          type="submit"
          color="red"
          variant="regular"
        >
          {isLoading ? (
            <>{getIcon("spinner")} Sletter..</>
          ) : (
            <>Slett alt innhold</>
          )}
        </Button>
      </ButtonsWrapper>
    </>
  );
};

export default DeleteModal;
